










import {Component, Prop, Vue} from 'vue-property-decorator';
import GridCell from '../classes/GridCell';

export enum CellContent {
    Nothing = 'space',
    Wall = 'wall',
    Cat = 'cat',
    Mouse = 'mouse',
    Milk = 'milk',
}

@Component
export default class MazeCell extends Vue {
    @Prop() private cellData!: GridCell;

    private CellContent = CellContent;

    private get content(): CellContent {
        return this.cellData.content;
    }

    private get isSpinning(): boolean {
        return this.cellData.isSpinning;
    }
}
